import { defineComponent as ee, ref as c, toRef as te, computed as a, withDirectives as le, openBlock as r, createElementBlock as m, normalizeClass as I, unref as i, renderSlot as f, createCommentVNode as d, createBlock as u, resolveDynamicComponent as h, normalizeStyle as z, withCtx as T, Fragment as ie, renderList as re, mergeProps as F, toHandlers as se, createVNode as oe } from "vue";
import { u as ae, r as de, g as ne } from "./useRecycleScroller-D_RDrEg2.js";
import { _ as ce, R as me, O as fe } from "./scroller.css_vue_type_style_index_0_src_true_lang--7gJ3zh_.js";
const Se = /* @__PURE__ */ ee({
  __name: "RecycleScroller",
  props: {
    items: {},
    keyField: { default: "id" },
    direction: { default: "vertical" },
    listTag: { default: "div" },
    itemTag: { default: "div" },
    itemSize: { default: null },
    gridItems: { default: void 0 },
    itemSecondarySize: { default: void 0 },
    minItemSize: { default: null },
    sizeField: { default: "size" },
    typeField: { default: "type" },
    buffer: { default: 200 },
    pageMode: { type: Boolean, default: !1 },
    scrollParent: { default: void 0 },
    shift: { type: Boolean, default: !1 },
    cache: { default: void 0 },
    prerender: { default: 0 },
    emitUpdate: { type: Boolean, default: !1 },
    disableTransform: { type: Boolean, default: !1 },
    flowMode: { type: Boolean, default: !1 },
    hiddenPosition: { default: void 0 },
    updateInterval: { default: 0 },
    itemsLimit: { default: void 0 },
    skipHover: { type: Boolean, default: !1 },
    enabled: { type: Boolean, default: !0 },
    listClass: { default: "" },
    itemClass: { default: "" }
  },
  emits: ["resize", "visible", "hidden", "update", "scrollStart", "scrollEnd"],
  setup($, { expose: w, emit: C }) {
    const e = $, s = C, M = fe, p = c(), b = c(), _ = c(), y = c(null), B = te(e, "items"), P = a(() => ({
      items: B,
      el: p,
      before: b,
      after: _,
      keyField: e.keyField,
      direction: e.direction,
      itemSize: e.itemSize,
      gridItems: e.gridItems,
      itemSecondarySize: e.itemSecondarySize,
      minItemSize: e.minItemSize,
      sizeField: e.sizeField,
      typeField: e.typeField,
      buffer: e.buffer,
      pageMode: e.pageMode,
      scrollParent: e.scrollParent,
      shift: e.shift,
      cache: e.cache,
      prerender: e.prerender,
      emitUpdate: e.emitUpdate,
      disableTransform: e.disableTransform,
      flowMode: e.flowMode,
      hiddenPosition: e.hiddenPosition,
      updateInterval: e.updateInterval,
      itemsLimit: e.itemsLimit,
      enabled: e.enabled,
      onResize: () => s("resize"),
      onVisible: () => s("visible"),
      onHidden: () => s("hidden"),
      onUpdate: (t, o, l, n) => {
        s("update", t, o, l, n), l <= 0 && s("scrollStart"), n >= e.items.length - 1 && s("scrollEnd");
      }
    })), H = ae(
      P
    ), {
      pool: V,
      visiblePool: R,
      totalSize: x,
      startSpacerSize: v,
      endSpacerSize: S,
      ready: k,
      scrollToItem: O,
      scrollToPosition: L,
      getScroll: N,
      findItemIndex: U,
      getItemOffset: K,
      getItemSize: W,
      getViewStyle: D,
      cacheSnapshot: E,
      restoreCache: A,
      updateVisibleItems: j,
      handleResize: q,
      handleVisibilityChange: G
    } = H, g = a(
      () => de({
        direction: e.direction,
        disableTransform: e.disableTransform,
        flowMode: e.flowMode,
        gridItems: e.gridItems
      }) === "flow"
    ), J = a(() => ({
      height: `${v.value}px`
    })), Q = a(() => ({
      height: `${S.value}px`
    }));
    function X(t) {
      y.value = t;
    }
    function Y() {
      y.value = null;
    }
    const Z = a(() => {
      const t = {
        [e.direction === "vertical" ? "minHeight" : "minWidth"]: `${x.value}px`
      }, o = ne(e.itemSize);
      if (e.gridItems && o != null) {
        const l = (e.itemSecondarySize || o) * e.gridItems;
        t[e.direction === "vertical" ? "minWidth" : "minHeight"] = `${l}px`;
      }
      return t;
    });
    return w({
      el: p,
      visiblePool: R,
      startSpacerSize: v,
      endSpacerSize: S,
      scrollToItem: O,
      scrollToPosition: L,
      getScroll: N,
      findItemIndex: U,
      getItemOffset: K,
      getItemSize: W,
      cacheSnapshot: E,
      restoreCache: A,
      updateVisibleItems: j
    }), (t, o) => le((r(), m("div", {
      ref_key: "el",
      ref: p,
      class: I(["vue-recycle-scroller", {
        "grid-mode": e.gridItems,
        "flow-mode": g.value,
        ready: i(k),
        "page-mode": e.pageMode,
        [`direction-${e.direction}`]: !0
      }])
    }, [
      t.$slots.before ? (r(), m("div", {
        key: 0,
        ref_key: "before",
        ref: b,
        class: "vue-recycle-scroller__slot"
      }, [
        f(t.$slots, "before")
      ], 512)) : d("", !0),
      (r(), u(h(e.listTag), {
        style: z(Z.value),
        class: I(["vue-recycle-scroller__item-wrapper", e.listClass])
      }, {
        default: T(() => [
          g.value && i(v) > 0 ? (r(), u(h(e.itemTag), {
            key: 0,
            "aria-hidden": "true",
            class: "vue-recycle-scroller__item-spacer",
            style: z(J.value)
          }, null, 8, ["style"])) : d("", !0),
          (r(!0), m(ie, null, re(i(V), (l) => (r(), u(ce, F({
            key: l.nr.id,
            view: l,
            "item-tag": e.itemTag,
            style: i(k) ? i(D)(l) : null,
            class: ["vue-recycle-scroller__item-view", [
              e.itemClass,
              {
                hover: !e.skipHover && y.value === l.nr.key
              }
            ]]
          }, se(e.skipHover ? {} : {
            mouseenter: () => {
              X(l.nr.key);
            },
            mouseleave: () => {
              Y();
            }
          })), {
            default: T((n) => [
              f(t.$slots, "default", F({ ref_for: !0 }, n))
            ]),
            _: 2
          }, 1040, ["view", "item-tag", "style", "class"]))), 128)),
          g.value && i(S) > 0 ? (r(), u(h(e.itemTag), {
            key: 1,
            "aria-hidden": "true",
            class: "vue-recycle-scroller__item-spacer",
            style: z(Q.value)
          }, null, 8, ["style"])) : d("", !0),
          e.items.length === 0 ? f(t.$slots, "empty", { key: 2 }) : d("", !0)
        ]),
        _: 3
      }, 8, ["style", "class"])),
      t.$slots.after ? (r(), m("div", {
        key: 1,
        ref_key: "after",
        ref: _,
        class: "vue-recycle-scroller__slot"
      }, [
        f(t.$slots, "after")
      ], 512)) : d("", !0),
      oe(me, { onNotify: i(q) }, null, 8, ["onNotify"])
    ], 2)), [
      [i(M), i(G)]
    ]);
  }
});
export {
  Se as _
};
//# sourceMappingURL=RecycleScroller.vue_vue_type_script_setup_true_lang-C7mZBLYi.js.map
